export interface RenderData {
  name?: string;
  value: any;
  stepId: any;
  id?: string;
  type?: string;
  options?: Record<string, any>;
}

export const NULL_CHAR = "\u2205";

export type ImageResult = {
  kind: 'image',
  src: string,
  caption?: string,
}

export type ImageGroupResult = {
  kind: 'imageGroup',
  images: ImageResult[],
  title?: string,
}

export type StringResult = {
  kind: 'string',
  value: string,
}

export type HTMLResult = {
  kind: 'html',
  value: string,
}

export type TableResult = ImageResult | ImageGroupResult | StringResult | HTMLResult;
